<router-outlet (activate)="customeScroll()"></router-outlet>
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="default"
  color = "#007dbc"
  type="line-scale-pulse-out"
  [fullScreen] = "true"
>
  <p style="color: rgb(116, 67, 67)"></p>
</ngx-spinner>